var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlace(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.659668,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#1c3988"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4695 18.2035C11.3424 17.8025 10.7789 17.6019 10.611 17.2978C10.4655 17.0342 10.4587 16.716 10.5928 16.4464C10.7475 16.1354 11.302 15.911 12.4109 15.4621L22.8631 11.2315C23.9552 10.7894 24.5012 10.5684 24.8462 10.6817C25.1457 10.7801 25.3805 11.0149 25.4789 11.3144C25.5922 11.6593 25.3712 12.2054 24.9292 13.2975L20.6985 23.7497C20.2497 24.8586 20.0252 25.4131 19.7142 25.5679C19.4447 25.702 19.1264 25.6951 18.8628 25.5496C18.5587 25.3817 18.3582 24.8182 17.9572 23.6911L16.7293 20.2405C16.6513 20.0212 16.6123 19.9115 16.5486 19.82C16.4922 19.7389 16.4217 19.6685 16.3406 19.612C16.249 19.5483 16.1394 19.5093 15.9201 19.4313L12.4695 18.2035Z",
    stroke: "#1c3988",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlace);
export default __webpack_public_path__ + "static/media/place.215b1c077e3564404cb4e4c87cbb8644.svg";
export { ForwardRef as ReactComponent };